<div class="aplayer aplayer-withlist" :class="{ 'aplayer-withlrc': showlrc, 'aplayer-narrow': narrow }">
  <vPicture :url="currentMusic.pic">
    <div :class="`aplayer-button aplayer-${status}`" @click="toggle">
      <vButton :type="status" :icon="status" :title="media.paused ? '播放' : '暂停'" />
    </div>
  </vPicture>
  <template v-if="!narrow">
    <Container>
      <Info slot="info" :title="currentMusic.title" :author="currentMusic.author" />
      <Lyric slot="lyric" v-if="showlrc" :currentTime="media.currentTime" :lrc="currentMusic.lrc" />
      <Controller slot="controller">
        <ProgressBar slot="progress" :loaded="loaded" :played="played" @change="progressChangeHandler" />
        <TimeBar slot="time" :currentTime="media.currentTime" :duration="media.duration" />
        <Volume slot="volume" :value="volume" @toggle="toggleVolume" @change="setVolume" />
        <vButton slot="mode" type="mode" :icon="playMode" @click="togglePlayMode" :title="displayPlayMode" />
        <vButton slot="menu" type="menu" icon="menu" @click="toggleCollapsed" :title="collapsed ? '展开' : '收起'" />
      </Controller>
    </Container>
    <List ref="list" :scrollTop="currentMusicOffsetTop" :music="music" :maxheight="listmaxheight" :collapsed="collapsed">
      <Item ref="items" v-for="(music, index) in music"
        :key="music.id"
        :id="music.id"
        :index="index + 1"
        :title="music.title"
        :author="music.author"
        :active="music.id === currentMusic.id"
        :remove="remove"
        @click="playHandler(music)"
        @render="setCurrentMusicOffsetTop(index)"
        @delete="deleteMusic(index)" />
    </List>
  </template>
</div>



// WEBPACK FOOTER //
// ./src/components/APlayer/src/APlayer.html